export const BEFORE_END_DATE_ERROR = 'Must be before end date';
export const IS_REQUIRED_ERROR = 'This is required';
export const NO_CONFIGURED_SERVICES_ERROR = 'No services have been configured for this contract';
export const NO_CONTRACT_ERROR = 'Please select a contract';
export const NO_CURRENT_PARTICIPANT_ERROR = 'No current participant';
export const NO_FIELDS_ERROR = 'Please fill in at least one field';
export const NO_UPDATE_ERROR = 'There is nothing to update.';
export const NO_VALUE_SELECTED_ERROR = 'Please select a value';
export const NOT_FUTURE_DATE_ERROR = 'Must be a future date';
export const PAST_DATE_ERROR = 'Cannot be a past date';
export const AGE_UNDER_SIXTEEN = 'The participant is under 16 years of age.';
export const UNIDENTIFIED_UNIQUE_IDENTIFIER_TYPE =
    'Unidentified unique identifier type. Contact support';
